"use strict";
// @ts-ignore
try {
    self['workbox:broadcast-update:7.0.0'] && _();
}
catch (e) { }
